import React from "react";

// Reusable action button for flow toolbars (ERA view, future pipelines, etc.).
// variant: "solid" (dark, primary) | "outline" (white, secondary)
export const ActionButton = React.forwardRef(function ActionButton(
  { icon: Icon, children, variant = "outline", className = "", ...props },
  ref
) {
  const base =
    "inline-flex items-center gap-2 text-[12.5px] font-semibold px-[15px] py-[9px] rounded-[11px] transition disabled:opacity-50 disabled:cursor-not-allowed";
  const styles =
    variant === "solid"
      ? "bg-[#1d1d1f] text-white hover:opacity-90"
      : "bg-white border border-black/[.08] text-[#1d1d1f] hover:bg-black/[.03]";
  return (
    <button ref={ref} className={`${base} ${styles} ${className}`} {...props}>
      {Icon ? <Icon size={15} /> : null}
      {children}
    </button>
  );
});

export default ActionButton;
